import { render, staticRenderFns } from "./Calculo.vue?vue&type=template&id=ef14f47c&scoped=true&"
import script from "./Calculo.vue?vue&type=script&lang=js&"
export * from "./Calculo.vue?vue&type=script&lang=js&"
import style0 from "./Calculo.vue?vue&type=style&index=0&id=ef14f47c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef14f47c",
  null
  
)

export default component.exports